<div>
  <app-kf-configuration-admin-filter (search)="searchKfConfiguration($event)">
  </app-kf-configuration-admin-filter>
  <mat-divider></mat-divider>
  <app-kf-configuration-admin-table *ngIf="kfConfigurationPage"
                                    [page]="kfConfigurationPage.number"
                                    [pageSize]="kfConfigurationPage.size"
                                    [totalElements]="kfConfigurationPage.totalElements"
                                    [kfConfigurations]="kfConfigurationPage.content"
                                    (loadKfConfigurations)="loadKfConfigurations($event)"
                                    (reopenConfiguration)="reopenConfiguration($event)"
                                    (printKfConfiguration)="printPdf($event)"
  ></app-kf-configuration-admin-table>

</div>
